import { DatePipe } from '@angular/common';
import { Component, OnInit, ViewChild } from '@angular/core';
import { DxDataGridComponent } from 'devextreme-angular';
import {Observable, firstValueFrom, interval, map, takeUntil, take} from 'rxjs';
import {
  ProductionOrderOperation,
  ProductionOrder,
  Worker,
  TId,
  TimeTicket,
  TimerTimeTikets,
  AssetOrganization
} from '../../../../models';
import { GenericReadOnlyResource } from '../../../../resources';
import { MasterApiService } from '../../../../services/master-api.service';
import { AddTimerListComponent } from './components/add-timer-list/add-timer-list.component';
import { AlertService } from '../../../../services/alert.service';
import { AclService } from '../../../../libs/services/acl.service';
import { TranslateService } from '@ngx-translate/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { fromTimeSpanStringToSeconds, secondsToHhmmss } from '../../../../libs/utils';
import {
  OmsManufacturingOrdersEditComponent
} from "../../production/oms-manufacturing-orders/oms-manufacturing-orders-edit/oms-manufacturing-orders-edit.component";
import {TabRole, TabsService} from "../../../../libs/components/tabs-host/tabs.service";
import {
  OrganizationsEditComponent
} from "../../../directory/directory-stakeholders/organizations/organizations-edit/organizations-edit.component";


@Component({
    selector: 'app-timers-list',
    templateUrl: './timers-list.component.html',
    styleUrl: './timers-list.component.sass',
    providers: [DatePipe],
    standalone: false
})
export class TimersListComponent implements OnInit {
canCreate(): string|undefined {
const dataSourceItems = this.dataGrid?.instance.getDataSource().items();
if(!this.isAdmin && dataSourceItems && dataSourceItems.length > 0) {
  return 'cantCreateTimer';
}
if(!this.workerId){
  return 'needAnUserToSeeSchedule';
}
return undefined;
}
  resource?: GenericReadOnlyResource<TimerTimeTikets>;
  orders: ProductionOrder[] = [];
  orderIds: TId[] =[];
  operations: ProductionOrderOperation[] = [];
  editTicket?: TimeTicket;
  workers: Worker[] = [];
  workerId: TId | undefined;
  isAdmin = this.acl.isAdmin()
  workerName: string = '';
  userHaveTimer: boolean = false;
  dataSourceItems: TimerTimeTikets[] = [];
  stopTimmerTitleTime = '';
  form: FormGroup | undefined;
  pendingTime: string = '';

  @ViewChild ('grid') dataGrid?: DxDataGridComponent;
  editComponentVisible: boolean = false;
  stopTimerPopupVisible: boolean = false;

  createTimer = AddTimerListComponent;

  constructor(private api: MasterApiService, private alert: AlertService, private acl: AclService, private tr: TranslateService, private fb: FormBuilder, private tabs: TabsService) {}
  async ngOnInit(): Promise<void> {



    if (this.isAdmin) this.workers = await firstValueFrom(this.api.resources.workers.getAll());
    if(this.isAdmin){
      this.setResource(undefined);
    } else {
      this.setWorkerId(this.api.auth.userValue!.workerId as TId);
      this.setResource(this.api.auth.userValue!.workerId as TId);
    }

    this.resource?.data$.subscribe((data) => {
      if(data) this.dataSourceItems = data;
    })

  }

  setWorkerId(workerId: TId) {
    this.workerId = workerId;
  }

  alert2TimersUser(){
    this.alert.warning(this.tr.instant('warnings.alert2TimersUser'))
  }


  onDataSourceChange($event: any){
    if($event.data.workerId === this.api.auth.userValue!.workerId){
      this.userHaveTimer = false
    }
  }


  setResource(workerId: TId | undefined): void {
    let resource;
    this.resource = undefined
    if(workerId){
      resource = this.api.resources.workerTimeTickets.contextualizeQueryParams({ workerId: workerId.toString(), temporary: 'true' })
    } else {
      resource = this.api.resources.workerTimeTickets.contextualizeQueryParams({ temporary: 'true' })
    }
    if(resource){
      this.resource = resource.asMappedResource({
        from: async (data) => {
          if(this.api.auth.userValue!.workerId == data.workerId){
            this.userHaveTimer = true;
          }

          if(!data.projectCode) {
            data.projectCode = '-';
          }
          if(!data.organizationName){
            data.organizationName = '-';
          }

          const timeDifference$ = this.getTimeDifference$(data.startDate);
          return { ...data, currentTime: timeDifference$ } as unknown as TimerTimeTikets
        }
      });
    }

  }

  getTimeDifference(date: Date): string {
    const now = new Date(); // Obtener la fecha actual
    date = new Date(date);

    // Obtener la diferencia en milisegundos
    const diferenceMS = Math.abs(now.getTime() - date.getTime());

    // Convertir a horas, minutos y segundos
    const hours = Math.floor(diferenceMS / (1000 * 60 * 60));
    const minutes = Math.floor((diferenceMS % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((diferenceMS % (1000 * 60)) / 1000);

    // Formatear los valores para que siempre tengan 2 dígitos
    const formatedHours = String(hours).padStart(2, '0');
    const formatedMinutes = String(minutes).padStart(2, '0');
    const formatedSeconds = String(seconds).padStart(2, '0');

    // Devolver el tiempo formateado como HH:MM:SS
    return `${formatedHours}:${formatedMinutes}:${formatedSeconds}`;
  }

  getTimeDifference$(date: Date): Observable<string> {
    return interval(1000).pipe(
      map(() => {
        const now = new Date();
        const diferenceMS = Math.abs(now.getTime() - new Date(date).getTime());

        const hours = Math.floor(diferenceMS / (1000 * 60 * 60));
        const minutes = Math.floor((diferenceMS % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((diferenceMS % (1000 * 60)) / 1000);

        const formatedHours = String(hours).padStart(2, '0');
        const formatedMinutes = String(minutes).padStart(2, '0');
        const formatedSeconds = String(seconds).padStart(2, '0');

        return `${formatedHours}:${formatedMinutes}:${formatedSeconds}`;
      })
    );
  }


  async stopTimer(TimerTimeTikets: TimeTicket) {

    const operation = await firstValueFrom(this.api.resources.operations.productionOrderOperations(TimerTimeTikets.productionOrderId).get(TimerTimeTikets.productionOrderOperationId))
    this.editTicket = TimerTimeTikets;
    this.stopTimmerTitleTime = this.getTimeDifference(this.editTicket!.startDate);
    if(operation.pendingTime) {
      this.pendingTime = operation.pendingTime
    } else {
      this.pendingTime = '00:00:00'
    }

    this.form = this.fb.group({
      pendingTime: [this.pendingTime]
    })

    this.stopTimerPopupVisible = true;

  }


  async deleteTimer(data: any) {
    const confirmed = await this.alert.confirm('common.deleteTimerConfirmation')
    if( confirmed ){
      try {
        await firstValueFrom(this.api.resources.workerTimeTickets.delete(data.id));
        if(this.api.auth.userValue!.workerId == data.workerId){
          this.userHaveTimer = false
        }
        this.dataGrid?.instance.refresh();
        this.alert.success(this.tr.instant('common.timerDeleted'));
      } catch (e) {
        console.log(e);
      }
    }
  }


  async stopAndSaveTime(){
    this.stopTimerPopupVisible = false;
    const totalTime = this.getTimeDifference(this.editTicket!.startDate);
    let pendingTime : string | null = this.pendingTime
    pendingTime = secondsToHhmmss(fromTimeSpanStringToSeconds(this.form?.value.pendingTime));
    if(pendingTime == '00:00:00'){
      pendingTime = null;
    }
    const data = { ...this.editTicket!, totalTime: totalTime, pendingTime: pendingTime  } as TimeTicket;
    const response = await firstValueFrom(this.api.resources.workerTimeTickets.put(data));
    if (response) {
      if(this.api.auth.userValue!.workerId == data.workerId){
        this.userHaveTimer = false
      }
      this.dataGrid?.instance.refresh();
      this.alert.success(this.tr.instant('common.timerStopped'));
    }
  }

  onEdit($event: TimeTicket) {
    this.dataGrid?.instance.refresh();
    this.editComponentVisible = false;
  }

  navigateToProductionOrderEditor(item: TimeTicket) {
    const tab = this.tabs.createTab(OmsManufacturingOrdersEditComponent, TabRole.EDITION, { inputPrms: { id: item.productionOrderId, resource: this.api.resources.operations.productionOrders()} });
    tab.component.instance.entityChanged.pipe(
      takeUntil(tab.destroy$),
      take(1)
    ).subscribe(productionOrderEdited => {
      tab.close();
    } );
  }

  navigateToOrganitzationEditor(organization: TimeTicket) {
    const tab = this.tabs.createTab(OrganizationsEditComponent, TabRole.EDITION, {
      inputPrms: {
        genericInfoAlternativeText: 'entity.organitzation.organitzation',
        id: organization.productionOrderOrganizationId,
      }
    });
    tab.component.instance.entityChanged.pipe(
      take(1),
    ).subscribe(async () => {
      tab.close();
    });
  }

}
